const DEMO_ACCOUNT_ALLOWED_ROLES = new Set([
  "super_admin",
  "admin",
  "sales_partner",
  "viewer"
]);

export function isDashboardAccountEligible(account, membershipRole) {
  const role = String(membershipRole || "").toLowerCase();

  if (!role) return false;

  if (account?.status === "demo") {
    return DEMO_ACCOUNT_ALLOWED_ROLES.has(role);
  }

  // Preserve the existing active-account behavior: an explicitly returned
  // membership is required, while role-based demo eligibility stays narrow.
  return account?.status === "active";
}

export function getDashboardAccountMode(account) {
  const accountType = String(account?.account_type || "competitive").toLowerCase();

  if (accountType === "local") return "local";
  if (account?.status === "demo") return "demo";
  return "competitive";
}
